import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Overline } from '@/components/ui';
import { formatCurrency } from '@/utils/formatters';

export interface BillHeroProps {
    amount: number;
    itemCount: number;
    orderTypeLabel: string;
    customer?: string;
    /** 44px figure on landscape */
    large?: boolean;
    className?: string;
}

/** O3 plum bill hero. */
export const BillHero: React.FC<BillHeroProps> = ({ amount, itemCount, orderTypeLabel, customer, large, className }) => {
    const { t } = useTranslation();
    return (
        <div className={clsx('flex flex-col gap-1 rounded-xl bg-surface-brand p-[20px_22px] text-white shadow-brand', className)}>
            <Overline tone="onBrand">{t('cart.totalBill')}</Overline>
            <span className={clsx('font-black tnum leading-[1.1] tracking-[-0.02em]', large ? 'text-[44px]' : 'text-metric')}>{formatCurrency(amount)}</span>
            <span className="text-[13px] text-primary-100">
                {t('cart.itemsCount', { count: itemCount })} · {orderTypeLabel}{customer ? ` · ${customer}` : ''}
            </span>
        </div>
    );
};
export default BillHero;
